import React from 'react';
import "./OverviewSubheader.scss";
import ReactTooltip from 'react-tooltip';
import {BsInfoCircle} from 'react-icons/bs'

export default function OverviewSubheader({left, right, tooltipDesc="Tooltip needed"}) {
  return(
    <div className="overview-subheader bg-black text-white">
      <div className="overview-subheader-left d-flex">
        {left}
        <div className="d-flex align-items-start" data-for="overviewTooltip" data-tip={tooltipDesc}>
            <BsInfoCircle style={{marginLeft: '7px'}} color="#ccc" size="0.70em"  />
        </div> 
        <ReactTooltip id="overviewTooltip" effect="solid" place="right" offset={{'right': 0, 'top': 8}} backgroundColor="#f5f5f5" textColor="#111" border={true} className="tooltip-width" />
      </div>
      <div className="overview-subheader-right">
        {right}
      </div>
    </div>
  );
}
